import { useSelector } from "react-redux";

import { useTeams } from "../../../reactQuery/teams";

export function useAllocationGroupingState() {
  const userTeamId = useSelector((state) => state.users.logInUser.team_id);
  const groupingUserFromRedux = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const { teams, isLoading: teamIsLoading } = useTeams();

  return {
    hasAssignedTeam: Boolean(userTeamId),
    teams,
    teamIsLoading,
    groupingUserFromRedux,
  };
}
